import { RE_INITIALIZE_SALES_REPORT_TOTAL_PERIOD_FILTER, RE_INITIALIZE_SALES_REPORT_TOTAL_SORT_FILTER, SET_SALES_REPORT_IS_LOADING, SET_SALES_REPORT_PERIOD, SET_SALES_REPORT_SORT_FILTER, SET_SALES_REPORT_TOTAL_PERIOD_FILTER, SET_SALES_REPORT_TOTAL_PERIOD_FILTER_READY, SET_SALES_REPORT_TOTAL_SALES, SET_SALES_REPORT_TOTAL_SUMMARY } from '../../actionTypes/salesReport'
import { startOfDay } from 'date-fns'

const initialState = {
	period: 'DAY',
	totalSales: [],
	isLoading: false,
	totalsSummary: null,
	periodFilter: {
		dateFrom: startOfDay(new Date()),
		dateTo: new Date(),
	},
	periodFilterReady: false,
	sortFilter: {
		orderByType: 'DATE',
		orderByAsc: true,
	},
}

export function salesReportReducer (state = initialState, action) {
	switch (action.type) {
		case SET_SALES_REPORT_PERIOD:
			return {
				...state,
				period: action.value,
			}
		case SET_SALES_REPORT_TOTAL_SALES:
			return {
				...state,
				totalSales: action.value,
			}
		case SET_SALES_REPORT_IS_LOADING:
			return {
				...state,
				isLoading: action.value,
			}
		case SET_SALES_REPORT_TOTAL_SUMMARY:
			return {
				...state,
				totalsSummary: action.value,
			}
		case SET_SALES_REPORT_TOTAL_PERIOD_FILTER:
			return {
				...state,
				periodFilter: {
					...state.periodFilter,
					...action.value,
				},
			}
		case RE_INITIALIZE_SALES_REPORT_TOTAL_PERIOD_FILTER:
			return {
				...state,
				periodFilter: {
					dateFrom: startOfDay(new Date()),
					dateTo: new Date(),
				},
			}
		case SET_SALES_REPORT_TOTAL_PERIOD_FILTER_READY:
			return {
				...state,
				periodFilterReady: action.value,
			}
		case SET_SALES_REPORT_SORT_FILTER:
			return {
				...state,
				sortFilter: {
					...state.sortFilter,
					...action.value,
				},
			}
		case RE_INITIALIZE_SALES_REPORT_TOTAL_SORT_FILTER:
			return {
				...state,
				sortFilter: {
					...initialState.sortFilter,
				},
			}
		default:
			return state
	}
}


